import React from 'react'
import './CybersecurityHero.scss'

export class CybersecurityHero extends React.Component {
  render() {
    return (
      <div
        className="cybersecurity-page-hero"
        style={{ backgroundImage: 'url(/cloudsecopsbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="text">
            <h1>Cybersecurity</h1>
            <h2>Defense-in-Depth Security for Mission-Critical Systems</h2>
          </div>
        </div>
      </div>
    )
  }
}

export default CybersecurityHero
